/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Home_Editor_ReturnInputs */

const en_wc_home_editor_return = /** @type {(inputs: Wc_Home_Editor_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to editor`)
};

/**
* | output |
* | --- |
* | "Return to editor" |
*
* @param {Wc_Home_Editor_ReturnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_home_editor_return = /** @type {((inputs?: Wc_Home_Editor_ReturnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Home_Editor_ReturnInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_home_editor_return(inputs)
});
export { wc_home_editor_return as "wc.home.editor_return" }